//import { useMemo, useState } from "react";
import CommonOrders from "../../common/CommonOrders"
//import CommonMessage from "../../common/CommonMessage";

const InTransit = () => {
     //const[message,setMessage]=useState("");
    // const [loading, setLoading] = useState(false);
    const columnDefs = [
            { field: "orderId", headerName: "Order ID" },
            { field: "orderType", headerName: "Order Type" },
            {
        field: "dateCreated",
        headerName: "Date Created",
      },
            { field: "wayBill", headerName: "WayBill" },
            { field: "courier", headerName: "Courier" },
            { field: "customerName", headerName: "Customer Name" },
            { field: "mobile", headerName: "Mobile" },
            { field: "email", headerName: "Email" },
            { field: "pincode", headerName: "Pincode" },
            { field: "city" },
            { field: "totalAmount", headerName: "Total Amount" },
            {
                headerName: "Products",
                field: "product",
                flex: 5,
                wrapText: true,
                autoHeight: true,
            },
            { field: "paymentType", headerName: "Payment Type" },
            { field: "diseaseName", headerName: "Disease Name" },
            { field: "courierStatus", headerName: "Courier Status" },
             {
        field: "teleCaller",
        headerName: "Tele Caller",
      },
      {
        field: "teamLeader",
        headerName: "Team Leader",
      },
        ]
    

    // All Grid Columns
    
    return (
        <>
         {/* <div class="container-fluid py-3"> */}
    {/* <CommonMessage text={message} /> */}
        <CommonOrders statusId={7} columnDefs={columnDefs} h4={"InTransit Orders"} />
         {/* </div> */}
        </>
    );
};
export default InTransit;